import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {Logger} from 'angular2-logger/core';
//TODO:  waiting for environment variable testing
//import *  as Config from '../app/config/staging.config.ts';

@Injectable()
export class LoggerService {

  public log: Logger;
  private level:string = 'DEBUG';
  constructor(public logger: Logger) {
    this.log = this.logger;
    // Set the log level using the config value
    // switch(Config.data.LogLevel) {
     switch(this.level) {
      case 'OFF':
        this.log.level = this.logger.Level.OFF;
        break;
      case 'ERROR':
        this.log.level = this.logger.Level.ERROR;
        break;
      case 'WARN':
        this.log.level = this.logger.Level.WARN;
        break;
      case 'INFO':
        this.log.level = this.logger.Level.INFO;
        break;
      case 'DEBUG':
        this.log.level = this.logger.Level.DEBUG;
        break;
      default:
        this.log.level = this.logger.Level.LOG;
    }
    console.log('Log level is ', this.log.level);
  }

}



// WEBPACK FOOTER //
// ./src/providers/logger-service.ts